module.exports = __webpack_public_path__ + "b5f1eda8f4284bb551e4991c3db7bac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/doanh-nghiep-xac-nhan.jpg
// module id = ./assets/images/partials/doanh-nghiep-xac-nhan.jpg
// module chunks = 0